const menu = {
    "sim": "SIM卡管理",
    "store": "库存管理",
    "index": "首页",
    "overview": "概览!",
    "home": "首页",
    "supervise": "监管中心",
    "device": "设备管理",
    "watch": "腕表管理",
    "superviseTemplate": "监管规则",
    "superviseCenter": "监管中心",
    "entityTemplate": "模板设置",
    "org": "机构管理",
    "alarm": "告警管理",
    "alarmSetting": "告警设置",
    "alarmList": "告警列表",
    "systemLog": "系统日志",
    "system": "系统管理",
    "deviceModel": "设备型号",
    "systemSetting": "系统设置",
    "statistics": "综合概览",
    visit: '来访记录',
}
export default menu